import React, { Component } from "react";
import { Table, Row, Col } from "reactstrap";
import { priceDisplay } from "../../../Constants/CommonConstant";
import ProviderUtils from "../../CommonComponent/ProviderUtils";

class CostHealthDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isAsp:
        this.props.isAsp !== null && this.props.isAsp !== undefined
          ? this.props.isAsp
          : false,
      hostOnlyAzure: ProviderUtils.hostOnly(
        this.props.providerName,
        this.props.data.metricsPlatform
      ),
      hostOnly: this.props.data.metricsPlatform === "Host",
      entityType:
        this.props.entityType !== undefined ? this.props.entityType : "vm",
    };
  }

  getTrendImage(trendValue) {
    if (trendValue === "Sharply Decreasing") {
      return (
        <img id="ArrowImage" src={require("../../../images/Low_01.png")} />
      );
    } else if (trendValue === "Decreasing") {
      return (
        <img id="ArrowImage" src={require("../../../images/Low_01.png")} />
      );
    } else if (trendValue === "Sharply Increasing") {
      return (
        <img id="ArrowImage" src={require("../../../images/High_01.png")} />
      );
    } else if (trendValue === "Increasing") {
      return (
        <img id="ArrowImage" src={require("../../../images/High_01.png")} />
      );
    } else if (trendValue === "Flat") {
      return (
        <img id="ArrowImage" src={require("../../../images/Normal_01.png")} />
      );
    }
  }
  render() {
    const { data, type } = this.props;
    return (
      <div className="panel" id="DetailsPanel" style={{ padding: "15px 0px" }}>
        <Row>
          <Col>
            <div
              id="TableHeader"
              align="Center"
              style={{ borderRadius: "10px 10px 0px 0px" }}
            >
              {type}
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <Table id={`tbl${this.props.typeID}`} bordered>
              <thead id="ColumnHeader">
                <tr>
                  <th>Resource Metrics</th>
                  <th>Original Spec </th>
                  <th>Original Limit</th>
                  <th>Original Threshold & Trend</th>
                  {/* <th>Adjusted Threshold</th> */}
                  <th>
                    {this.state.entityType === "db"
                      ? "Max Cost"
                      : this.state.entityType === "asp"
                      ? "Cost per ASP Instance"
                      : "Cost"}
                  </th>
                  <th>Usage</th>
                  <th>Health</th>
                </tr>
              </thead>
              <tbody style={{ backgroundColor: "white" }}>
                {data.vm.map((key, i) => {
                  let gpuRecommendation = data?.gpuDTO?.find(
                    (item) => item.recommendationChoiceNum === 0
                  );
                  let isGPU = gpuRecommendation?.currentGpuNum > 0 ? 2 : 0;

                  let gpuProcSubtext = "";
                  let gpuMemSubtext = "";

                  if (gpuRecommendation?.currentGpuNum) {
                    // GPU Proc Usage Subtitle
                    const totalCores =
                      gpuRecommendation.currentCUDACores;
                    const smClockGhz = (
                      gpuRecommendation.currentPerGpuMaxClocksFreqSMMHz / 1000
                    ).toFixed(2);
                    gpuProcSubtext = `${totalCores} cores (${gpuRecommendation.currentGpuNum} GPU), ${smClockGhz} GHz SM clock`;

                    // GPU Memory Usage Subtitle
                    gpuMemSubtext = `${gpuRecommendation.currentvRAMBandwithGBps} GB/s`;
                  }

                  // Extract and compute per-vCPU speed
                  const numVcpu = key.current_vcpu || 0;
                  const totalSpeed = parseFloat(key.current_speed) || 0;
                  const perVcpuRate =
                    numVcpu > 0 ? (totalSpeed / numVcpu).toFixed(1) : 0;

                  return (
                    i === 0 && (
                      <>
                        {i === 0 && gpuRecommendation?.currentGpuNum > 0 && (
                          <tr>
                            <td id="InnerRow">GPU Proc Usage</td>
                            {i === 0 ? (
                              <td
                                id="InnerRow"
                                rowspan={
                                  1 *
                                    (this.state.isAsp ||
                                    this.state.entityType === "db"
                                      ? 4
                                      : 3) +
                                  isGPU
                                }
                              >
                                {" "}
                                <Table>
                                  <tr>
                                    <td id="InnerRow">
                                      {key.current_vmsize_name}
                                      {key.hypervgeneration
                                        ? " (" + key.hypervgeneration + ")"
                                        : null}
                                    </td>
                                  </tr>
                                </Table>
                              </td>
                            ) : (
                              ""
                            )}
                            <td id="InnerRow">
                              <Table className="mb-0">
                                <tr>
                                  <td id="InnerRow">
                                    {parseFloat(
                                      gpuRecommendation?.currentPerGpuTensorTFlops *
                                        gpuRecommendation?.currentGpuNum || 1
                                    ).toFixed(2)}
                                    {` `}TFLOPS (TF16)
                                  </td>
                                </tr>
                                <tr>
                                  <td>({gpuProcSubtext})</td>
                                </tr>
                              </Table>
                            </td>
                            <td>
                              <Table>
                                <tr>
                                  <td id="InnerRow">
                                    {parseFloat(
                                      gpuRecommendation?.gpuSMUsed_current_thrshld
                                    ).toFixed(2)}
                                    {` `}TFLOPS
                                  </td>
                                  <td id="InnerRow">
                                    {this.state.hostOnlyAzure
                                      ? ""
                                      : this.getTrendImage(
                                          gpuRecommendation?.gpuUtilization_trends
                                        )}
                                  </td>
                                </tr>
                              </Table>
                            </td>
                            {/* <td id="InnerRow">
                              {parseFloat(
                                gpuRecommendation?.gpuSMUsed_adj_env
                              ).toFixed(2)}
                              {` `}TFLOPS
                            </td> */}
                            <td
                              id="InnerRow"
                              rowspan={
                                1 *
                                  (this.state.isAsp ||
                                  this.state.entityType === "db"
                                    ? 4
                                    : 3) +
                                isGPU
                              }
                            >
                              <Table>
                                <tr>
                                  <td id="InnerRow">
                                    {" "}
                                    {priceDisplay(
                                      key.current_vm_price,
                                      this.props.userCurrency
                                    )}
                                    /mo
                                  </td>
                                </tr>
                              </Table>
                            </td>
                            <td>
                              <Table>
                                <tr>
                                  <td id="InnerRow">
                                    {gpuRecommendation?.gpuUtilization_util}
                                  </td>
                                </tr>
                                <tr>
                                  <td id="InnerRow">
                                    GPU SM Used Aggr {` `}
                                    {parseFloat(
                                      gpuRecommendation?.gpuSMUsed_percent_util
                                    ).toFixed(2)}
                                    {` `}TFLOPS
                                  </td>
                                </tr>
                              </Table>
                            </td>
                            <td>
                              <Table>
                                <tr>
                                  <td id="InnerRow">
                                    {gpuRecommendation?.gpu_sm_health}
                                  </td>
                                </tr>
                                <tr>
                                  <td id="InnerRow">
                                    GPU SM Utilization Aggr (
                                    {parseFloat(
                                      gpuRecommendation?.gpuSMUtilisation_health_val
                                    ).toFixed(2)}
                                    %)
                                  </td>
                                </tr>
                                {/* <tr>
                                  <td id="InnerRow">
                                    GPU SM Saturation Aggr (
                                    {parseFloat(
                                      gpuRecommendation?.gpuSMSaturation_health_val
                                    ).toFixed(2)}
                                    %)
                                  </td>
                                </tr> */}
                              </Table>
                            </td>
                          </tr>
                        )}

                        {i === 0 && gpuRecommendation?.currentGpuNum > 0 && (
                          <tr>
                            <td id="InnerRow">GPU Memory Usage</td>
                            <td id="InnerRow">
                              <Table className="mb-0">
                                <tr>
                                  <td id="InnerRow">
                                    {parseFloat(
                                      gpuRecommendation?.currentPerGpuMemorySizeGB *
                                        gpuRecommendation?.currentGpuNum || 1
                                    ).toFixed(2)}{" "}
                                    GB
                                  </td>
                                </tr>
                                <tr>
                                  <td>({gpuMemSubtext})</td>
                                </tr>
                              </Table>
                            </td>
                            <td>
                              <Table>
                                <tr>
                                  <td id="InnerRow">
                                    {parseFloat(
                                      gpuRecommendation?.gpuMemUsed_Aggr_current_thrshld /
                                        1024 /
                                        1024 /
                                        1024
                                    ).toFixed(2)}{" "}
                                    GB
                                  </td>
                                  <td id="InnerRow">
                                    {this.state.hostOnlyAzure
                                      ? ""
                                      : this.getTrendImage(
                                          gpuRecommendation?.gpuMemUsed_trends
                                        )}
                                  </td>
                                </tr>
                              </Table>
                            </td>
                            {/* <td id="InnerRow">
                              {parseFloat(
                                gpuRecommendation?.gpuMemUsed_adj_env /
                                  1024 /
                                  1024 /
                                  1024
                              ).toFixed(2)}{" "}
                              GiB
                            </td> */}
                            <td>
                              <Table>
                                <tr>
                                  <td id="InnerRow">
                                    {gpuRecommendation?.gpuMemUsed_util}
                                  </td>
                                </tr>
                                <tr>
                                  <td id="InnerRow">
                                    GPU Memory Used{" "}
                                    {parseFloat(
                                      gpuRecommendation?.gpuMemUsed_Aggr_current_thrshld /
                                        1024 /
                                        1024 /
                                        1024
                                    ).toFixed(2)}
                                    GB
                                  </td>
                                </tr>
                              </Table>
                            </td>
                            <td>
                              <Table>
                                <tr>
                                  <td id="InnerRow">
                                    {gpuRecommendation?.gpu_mem_health}
                                  </td>
                                </tr>
                                <tr>
                                  <td id="InnerRow">
                                    GPU Memory Utilization (
                                    {parseFloat(
                                      gpuRecommendation?.gpuMemUtilisation_health_val
                                    ).toFixed(2)}
                                    %)
                                  </td>
                                </tr>
                                <tr>
                                  <td id="InnerRow">
                                    GPU Memory Saturation Aggr (
                                    {parseFloat(
                                      gpuRecommendation?.gpuMemSaturation_health_val
                                    ).toFixed(2)}
                                    %)
                                  </td>
                                </tr>
                              </Table>
                            </td>
                          </tr>
                        )}

                        <tr>
                          {i === 0 ? (
                            <td id="InnerRow" rowspan={1}>
                              <Table>
                                <tr>
                                  <td id="InnerRow">
                                    {" "}
                                    {this.state.entityType === "db"
                                      ? "vCore CPU Usage"
                                      : "CPU Usage"}
                                  </td>
                                </tr>
                              </Table>
                            </td>
                          ) : (
                            ""
                          )}
                          {i === 0 && !isGPU ? (
                            <td
                              id="InnerRow"
                              rowspan={
                                1 *
                                (this.state.isAsp ||
                                this.state.entityType === "db"
                                  ? 4
                                  : 3)
                              }
                            >
                              {" "}
                              <Table>
                                <tr>
                                  <td id="InnerRow">
                                    {key.current_vmsize_name}
                                    {key.hypervgeneration
                                      ? " (" + key.hypervgeneration + ")"
                                      : null}
                                  </td>
                                </tr>
                              </Table>
                            </td>
                          ) : (
                            ""
                          )}
                          <td id="InnerRow">
                            <Table>
                              <tr>
                                <td>
                                  {this.state.entityType === "db"
                                    ? parseFloat(key.current_vcpu).toFixed(1)
                                    : key.current_speed}{" "}
                                  {this.state.isAsp
                                    ? "ACUs"
                                    : this.state.entityType === "db"
                                    ? "vCore"
                                    : ""}
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  {this.state.entityType === "db"
                                    ? null
                                    : `(${numVcpu} vCPUs, ${perVcpuRate} GHz)`}
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  {this.state.entityType === "db"
                                    ? key.current_speed
                                    : null}
                                </td>
                              </tr>
                            </Table>
                          </td>
                          <td>
                            <Table>
                              <tr>
                                <td id="DoubleInnerRow">
                                  {key.cpuused}{" "}
                                  {this.state.isAsp
                                    ? "ACUs"
                                    : this.state.entityType === "db"
                                    ? "GHz"
                                    : "GHz"}
                                  &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;
                                </td>
                                <td id="InnerRow">
                                  {this.getTrendImage(key.current_vcpu_trends)}
                                </td>
                              </tr>
                            </Table>
                          </td>
                          {/* <td>
                          <Table>
                            <tr>
                              <td id="DoubleInnerRow">
                                {key.adjusted_cpuused}{" "}
                                {this.state.isAsp
                                  ? "ACUs"
                                  : this.state.entityType === "db"
                                  ? "GHz"
                                  : "GHz"}
                              </td>
                            </tr>
                          </Table>
                        </td> */}

                          {!isGPU && (
                            <td
                              id="InnerRow"
                              rowspan={
                                1 *
                                (this.state.isAsp ||
                                this.state.entityType === "db"
                                  ? 4
                                  : 3)
                              }
                            >
                              <Table>
                                <tr>
                                  <td id="InnerRow">
                                    {" "}
                                    {priceDisplay(
                                      key.current_vm_price,
                                      this.props.userCurrency
                                    )}
                                    /mo
                                  </td>
                                </tr>
                              </Table>
                            </td>
                          )}

                          <td id="veticalAlignment">
                            <Table>
                              <tr>
                                <td id="InnerRow">
                                  {key.current_vcpu_utilisation}
                                </td>
                              </tr>
                              <tr>
                                <td id="InnerRow">
                                  {this.state.entityType === "db"
                                    ? "Cpu Cycles Used"
                                    : "CPU Usage"}{" "}
                                  {parseFloat(
                                    key.current_vcpu_percent_utilisation
                                  ).toFixed(2)}
                                </td>
                              </tr>
                            </Table>
                          </td>
                          <td id="veticalAlignment">
                            <Table>
                              <tr>
                                <td id="InnerRow">{key.current_vcpu_health}</td>
                              </tr>
                              <tr>
                                {this.state.isAsp ? (
                                  <td id="InnerRow">
                                    Response Time (
                                    {parseFloat(
                                      key.current_cpu_health_value
                                    ).toFixed(4)}
                                    )
                                  </td>
                                ) : this.state.entityType === "db" ? (
                                  <td id="InnerRow">
                                    Server Process Core Percentage (
                                    {parseFloat(
                                      key.current_cpu_health_value
                                    ).toFixed(4)}
                                    )
                                  </td>
                                ) : (
                                  <td id="InnerRow">
                                    {this.state.hostOnly
                                      ? "CPU Saturation"
                                      : "CPU Stolen"}{" "}
                                    ({key.current_cpu_health_value})
                                  </td>
                                )}
                              </tr>
                              {this.state.isAsp ? (
                                <tr>
                                  <td id="InnerRow">
                                    HTTP Queue Length (
                                    {parseFloat(
                                      key.current_mem_health_value
                                    ).toFixed(4)}
                                    )
                                  </td>
                                </tr>
                              ) : null}

                              {this.state.entityType === "db" ? (
                                <tr>
                                  <td id="InnerRow">
                                    {" "}
                                    Workers Percentage (
                                    {parseFloat(
                                      key.workersPercentage_health_val
                                    ).toFixed(4)}
                                    )
                                  </td>
                                </tr>
                              ) : null}
                              {this.state.entityType === "db" ? (
                                <tr>
                                  <td id="InnerRow">
                                    {" "}
                                    Session Percentage (
                                    {parseFloat(
                                      key.sessionsPercentage_health_val
                                    ).toFixed(4)}
                                    )
                                  </td>
                                </tr>
                              ) : null}
                            </Table>
                          </td>
                        </tr>
                      </>
                    )
                  );
                })}

                {this.state.entityType === "db"
                  ? data.osdisk.map((key, i) => {
                      return i === 0 ? (
                        <tr key={i}>
                          <td id="InnerRow" rowSpan={1}>
                            {" "}
                            <Table>
                              <tr>
                                <td id="InnerRow">vCore Memory Usage</td>
                              </tr>
                            </Table>
                          </td>
                          <td>{key.current_os_disk_memory} GiB </td>
                          <td>
                            <Table>
                              <tr>
                                <td id="DoubleInnerRow">
                                  {key.os_readiops} GiB
                                </td>
                                <td id="InnerRow">
                                  {" "}
                                  {this.getTrendImage(
                                    key.current_os_disk_read_iops_trends
                                  )}
                                </td>
                              </tr>
                            </Table>
                          </td>
                          {/* <td>
                            <Table>
                              <tr>
                                <td>{key.adjusted_os_readiops} GiB</td>
                              </tr>
                            </Table>
                          </td> */}

                          <td id="veticalAlignment">
                            <Table>
                              <tr>
                                <td id="InnerRow">
                                  {key.current_os_disk_utilisation}
                                </td>
                              </tr>
                              <tr>
                                <td id="InnerRow">
                                  Memory Used{" "}
                                  {parseFloat(
                                    key.diskReadIOPS_OS_PERCENT_UTIL
                                  ).toFixed(2)}
                                </td>
                              </tr>
                            </Table>
                          </td>
                          <td id="verticalAlignment">
                            {data.vm.map((vmkey, i) => {
                              return (
                                <Table>
                                  <tr>
                                    <td id="InnerRow">
                                      {key.current_os_disk_health}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td id="InnerRow">
                                      {" "}
                                      Server Process Memory Percentage (
                                      {parseFloat(
                                        vmkey.serverProcessMemPercentage_health_val
                                      ).toFixed(4)}
                                      )
                                    </td>
                                  </tr>
                                  <tr>
                                    <td id="InnerRow">
                                      {" "}
                                      Workers Percentage (
                                      {parseFloat(
                                        vmkey.workersPercentage_health_val
                                      ).toFixed(4)}
                                      )
                                    </td>
                                  </tr>
                                  <tr>
                                    <td id="InnerRow">
                                      {" "}
                                      Session Percentage (
                                      {parseFloat(
                                        vmkey.sessionsPercentage_health_val
                                      ).toFixed(4)}
                                      )
                                    </td>
                                  </tr>
                                </Table>
                              );
                            })}
                          </td>
                        </tr>
                      ) : (
                        ""
                      );
                    })
                  : null}

                {data.vm.map((key, i) => {
                  return (
                    i === 0 && (
                      <tr key={i} id="Row">
                        {i === 0 ? (
                          <td id="InnerRow" rowSpan={1}>
                            <Table>
                              <tr>
                                <td id="InnerRow">
                                  {this.state.entityType === "db"
                                    ? "Data Disk Usage"
                                    : "Memory Usage"}
                                </td>
                              </tr>
                            </Table>
                          </td>
                        ) : (
                          ""
                        )}
                        <td>
                          <Table>
                            {this.state.entityType === "db" ? (
                              <tr>
                                <td id="NumRightAlign">
                                  {key.current_data_space}
                                </td>
                              </tr>
                            ) : null}
                            <tr>
                              <td id="NumRightAlign">
                                {parseFloat(key.current_memory).toFixed(2)}{" "}
                                {this.state.entityType === "db"
                                  ? "IOPS"
                                  : "GiB"}
                              </td>
                            </tr>
                          </Table>
                        </td>
                        <td>
                          <Table>
                            <tr>
                              <td id="DoubleInnerRow">
                                {this.state.hostOnlyAzure
                                  ? "N/A"
                                  : this.state.entityType === "db"
                                  ? key.data_storage_used
                                  : parseFloat(key.memused).toFixed(2)}{" "}
                                {this.state.hostOnlyAzure
                                  ? ""
                                  : this.state.entityType === "db"
                                  ? "GiB"
                                  : "GiB"}
                              </td>
                              <td id="InnerRow">
                                {this.state.hostOnlyAzure
                                  ? ""
                                  : this.getTrendImage(
                                      key.current_memory_trends
                                    )}
                              </td>
                            </tr>
                            {this.state.entityType === "db" ? (
                              <tr>
                                <td id="DoubleInnerRow">
                                  {parseFloat(key.memused).toFixed(2)} IOPS
                                </td>
                                <td id="InnerRow">
                                  {this.state.hostOnlyAzure
                                    ? ""
                                    : this.getTrendImage(
                                        key.current_data_storage_trends
                                      )}
                                </td>
                              </tr>
                            ) : null}
                          </Table>
                        </td>
                        {/* <td>
                        <Table>
                          <tr>
                            <td id="DoubleInnerRow">
                              {this.state.hostOnlyAzure
                                ? "N/A"
                                : this.state.entityType === "db"
                                ? key.adjusted_data_storage_used
                                : parseFloat(key.adjusted_memused).toFixed(
                                    2
                                  )}{" "}
                              {this.state.hostOnlyAzure
                                ? ""
                                : this.state.entityType === "db"
                                ? "GiB"
                                : "GiB"}
                            </td>
                          </tr>
                          {this.state.entityType === "db" ? (
                            <tr>
                              <td id="DoubleInnerRow">
                                {parseFloat(key.adjusted_memused).toFixed(2)}{" "}
                                IOPS
                              </td>
                            </tr>
                          ) : null}
                        </Table>
                      </td> */}
                        <td id="veticalAlignment">
                          <Table>
                            <tr rowSpan={this.state.hostOnlyAzure ? "2" : "1"}>
                              <td id="InnerRow">
                                {this.state.hostOnlyAzure
                                  ? "N/A"
                                  : key.current_memory_utilisation}
                              </td>
                            </tr>
                            {this.state.hostOnlyAzure ? (
                              ""
                            ) : this.state.entityType === "db" ? (
                              <tr>
                                <td id="InnerRow">
                                  Data Storage Percentage{" "}
                                  {parseFloat(
                                    key.current_data_storage_percent_utilization
                                  ).toFixed(2)}
                                </td>
                              </tr>
                            ) : (
                              <tr>
                                <td id="InnerRow">
                                  Memory Usage{" "}
                                  {parseFloat(
                                    key.current_memory_percent_utilisation
                                  ).toFixed(2)}
                                </td>
                              </tr>
                            )}
                            {this.state.entityType === "db" ? (
                              <tr>
                                <td id="InnerRow">
                                  Data IO Percentage (
                                  {parseFloat(
                                    key.current_memory_percent_utilisation
                                  ).toFixed(2)}
                                  )
                                </td>
                              </tr>
                            ) : null}
                          </Table>
                        </td>

                        <td id="veticalAlignment">
                          {this.state.isAsp ? (
                            <Table>
                              <tr>
                                <td id="InnerRow">
                                  {" "}
                                  {key.current_memory_health}
                                </td>
                              </tr>
                              <tr>
                                <td id="InnerRow">
                                  Response Time (
                                  {parseFloat(
                                    key.current_cpu_health_value
                                  ).toFixed(4)}
                                  )
                                </td>
                              </tr>
                              <tr>
                                <td id="InnerRow">
                                  HTTP Queue Length (
                                  {parseFloat(
                                    key.current_mem_health_value
                                  ).toFixed(4)}
                                  )
                                </td>
                              </tr>
                            </Table>
                          ) : (
                            <Table>
                              <tr
                                rowSpan={this.state.hostOnlyAzure ? "2" : "1"}
                              >
                                <td id="InnerRow">
                                  {" "}
                                  {this.state.hostOnlyAzure
                                    ? "N/A"
                                    : key.current_memory_health}
                                </td>
                              </tr>
                              {this.state.hostOnlyAzure ? (
                                ""
                              ) : (
                                <tr>
                                  {this.state.isAsp ? (
                                    <td id="InnerRow">
                                      HTTP Queue Length (
                                      {parseFloat(
                                        key.current_mem_health_value
                                      ).toFixed(4)}
                                      )
                                    </td>
                                  ) : this.state.entityType === "db" ? (
                                    <td id="InnerRow">
                                      Data Storage Percentage (
                                      {key.current_data_storage_health_value})
                                    </td>
                                  ) : (
                                    <td id="InnerRow">
                                      Memory Saturation Percent (
                                      {key.current_mem_health_value})
                                    </td>
                                  )}
                                </tr>
                              )}
                              {this.state.entityType === "db" ? (
                                <tr>
                                  <td id="InnerRow">
                                    Data IO Percentage (
                                    {parseFloat(
                                      key.current_mem_health_value
                                    ).toFixed(2)}
                                    )
                                  </td>
                                </tr>
                              ) : null}
                            </Table>
                          )}
                        </td>
                      </tr>
                    )
                  );
                })}
                {data.vm.map((key, i) => {
                  return (
                    i === 0 && (
                      <tr key={i}>
                        {i === 0 ? (
                          <td id="InnerRow" rowSpan={1}>
                            <Table>
                              <tr>
                                <td id="InnerRow">
                                  {this.state.entityType === "db"
                                    ? "Log Disk Usage"
                                    : "Network Bandwidth"}
                                </td>
                              </tr>
                            </Table>
                          </td>
                        ) : (
                          ""
                        )}
                        <td>
                          <Table>
                            {this.state.entityType === "db" ? (
                              <tr>
                                <td id="NumRightAlign">
                                  {key.current_log_space}
                                </td>
                              </tr>
                            ) : null}
                            <tr>
                              <td id="NumRightAlign">
                                {key.current_network_bandwidth}
                              </td>
                            </tr>
                          </Table>
                        </td>
                        <td>
                          <Table>
                            {this.state.entityType !== "db" ? (
                              <tr>
                                <td id="HalfRowNtwBorder">
                                  TX{" "}
                                  {parseFloat(key.nettxbandwidth_aggr).toFixed(
                                    4
                                  )}{" "}
                                  Mbps
                                </td>
                                <td id="HalfRowNtwBorder">
                                  {this.getTrendImage(
                                    key.current_network_tx_trends
                                  )}{" "}
                                </td>
                              </tr>
                            ) : null}
                            {this.state.entityType === "db" ? (
                              <tr>
                                <td id="DoubleInnerRow">
                                  {parseFloat(key.nettxbandwidth_aggr).toFixed(
                                    2
                                  )}{" "}
                                  GiB
                                </td>
                                <td id="InnerRow">
                                  {" "}
                                  {this.getTrendImage(
                                    key.current_network_tx_trends
                                  )}{" "}
                                </td>
                              </tr>
                            ) : (
                              <tr>
                                <td id="HalfRowNtw">
                                  RX{" "}
                                  {parseFloat(key.netrxbandwidth_aggr).toFixed(
                                    4
                                  )}{" "}
                                  Mbps
                                </td>
                                <td id="HalfRowNtw">
                                  {" "}
                                  {this.getTrendImage(
                                    key.current_network_rx_trends
                                  )}{" "}
                                </td>
                              </tr>
                            )}
                            {this.state.entityType === "db" ? (
                              <tr>
                                <td if="DoubleInnerRow">
                                  {parseFloat(key.netrxbandwidth_aggr).toFixed(
                                    4
                                  )}{" "}
                                  Mbps
                                </td>
                                <td id="InnerRow">
                                  {" "}
                                  {this.getTrendImage(
                                    key.current_network_rx_trends
                                  )}{" "}
                                </td>
                              </tr>
                            ) : null}
                          </Table>
                        </td>
                        {/* <td>
                        <Table>
                          {this.state.entityType !== "db" ? (
                            <tr>
                              <td id="HalfRowNtwBorder">
                                TX{" "}
                                {parseFloat(
                                  key.adjusted_nettxbandwidth_aggr
                                ).toFixed(4)}{" "}
                                Mbps
                              </td>
                            </tr>
                          ) : null}
                          {this.state.entityType === "db" ? (
                            <tr>
                              <td id="DoubleInnerRow">
                                {parseFloat(
                                  key.adjusted_nettxbandwidth_aggr
                                ).toFixed(2)}{" "}
                                GiB
                              </td>
                            </tr>
                          ) : (
                            <tr>
                              <td id="HalfRowNtw">
                                RX{" "}
                                {parseFloat(
                                  key.adjusted_netrxbandwidth_aggr
                                ).toFixed(4)}{" "}
                                Mbps
                              </td>
                            </tr>
                          )}
                          {this.state.entityType === "db" ? (
                            <tr>
                              <td id="DoubleInnerRow">
                                {parseFloat(
                                  key.adjusted_netrxbandwidth_aggr
                                ).toFixed(4)}{" "}
                                Mbps
                              </td>
                            </tr>
                          ) : null}
                        </Table>
                      </td> */}
                        <td id="veticalAlignment">
                          <Table>
                            <tr>
                              <td id="InnerRow">
                                {key.current_network_utilisation}
                              </td>
                            </tr>
                            {this.state.entityType !== "db" ? (
                              <tr>
                                <td id="InnerRow">
                                  TX Bandwidth Usage{" "}
                                  {parseFloat(
                                    key.current_network_tx_bw_percent_utilisation
                                  ).toFixed(4)}
                                </td>
                              </tr>
                            ) : null}
                            {this.state.entityType === "db" ? (
                              <tr>
                                {" "}
                                <td id="InnerRow">
                                  Log Storage Used (
                                  {parseFloat(
                                    key.current_network_rx_bw_percent_utilisation
                                  ).toFixed(4)}
                                  )
                                </td>
                              </tr>
                            ) : (
                              <tr>
                                <td id="InnerRow">
                                  RX Bandwidth Usage{" "}
                                  {parseFloat(
                                    key.current_network_rx_bw_percent_utilisation
                                  ).toFixed(4)}
                                </td>
                              </tr>
                            )}
                            {this.state.entityType === "db" ? (
                              <tr>
                                {" "}
                                <td id="InnerRow">
                                  Log IO Used (
                                  {parseFloat(
                                    key.current_network_tx_bw_percent_utilisation
                                  ).toFixed(4)}
                                  )
                                </td>
                              </tr>
                            ) : null}
                          </Table>
                        </td>
                        <td id="veticalAlignment">
                          <Table>
                            <tr>
                              <td id="InnerRow">
                                {" "}
                                {key.current_network_health}
                              </td>
                            </tr>
                            {this.state.entityType !== "db" ? (
                              <tr>
                                {this.state.isAsp ? (
                                  <td id="InnerRow">
                                    HTTP Queue Length (
                                    {parseFloat(
                                      key.netRXPacketSize_health_value
                                    ).toFixed(4)}
                                    )
                                  </td>
                                ) : (
                                  <td id="InnerRow">
                                    Network TX PacketSize (
                                    {key.netRXPacketSize_health_value} bytes)
                                  </td>
                                )}
                              </tr>
                            ) : null}
                            {this.state.isAsp ? (
                              ""
                            ) : this.state.entityType === "db" ? (
                              <tr>
                                <td id="InnerRow">
                                  Log Storage Percentage(
                                  {key.netTXPacketSize_health_value})
                                </td>
                              </tr>
                            ) : (
                              <tr>
                                <td id="InnerRow">
                                  Network RX PacketSize (
                                  {key.netTXPacketSize_health_value})
                                </td>
                              </tr>
                            )}
                            {this.state.entityType === "db" ? (
                              <tr>
                                <td id="InnerRow">
                                  Log IO Percentage(
                                  {key.netRXPacketSize_health_value})
                                </td>
                              </tr>
                            ) : null}
                          </Table>
                        </td>
                      </tr>
                    )
                  );
                })}
                {this.state.entityType !== "db"
                  ? data.osdisk.map((key, i) => {
                      // Format OS disk size
                      const osDiskSize = key?.current_os_disk_memory;
                      const osText = osDiskSize ? `${osDiskSize}` : null;
                      return i === 0 ? (
                        <tr key={i}>
                          <td
                            id="InnerRow"
                            rowSpan={1 + Object.keys(data.dataDisk).length}
                          >
                            {" "}
                            <Table>
                              <tr>
                                <td id="InnerRow">
                                  {this.state.isAsp
                                    ? "Storage Used, Disk IOPS & Disk Throughput"
                                    : "Disk(s) IOPS & Throughput"}
                                </td>
                              </tr>
                            </Table>
                          </td>
                          {this.state.isAsp ? (
                            ""
                          ) : (
                            <td id="InnerRow">
                              OS Disk-
                              {key.current_os_disk_name
                                ? key.current_os_disk_name.toUpperCase()
                                : key.current_os_disk_name}
                            </td>
                          )}
                          <td>
                            <Table>
                              <tr>
                                <td id="HalfRowBorderLimit">
                                  {this.state.isAsp
                                    ? "--"
                                    : key.current_os_disk_iops}{" "}
                                  {this.state.isAsp ? "" : "IOPS"}{" "}
                                  {`(${osText})`}
                                </td>
                              </tr>
                              <tr>
                                <td id="HalfRowLimit">
                                  {this.state.isAsp
                                    ? "--"
                                    : key.current_os_disk_bandwidth}
                                </td>{" "}
                              </tr>
                            </Table>
                          </td>
                          <td>
                            <Table>
                              <tr>
                                <td id="HalfRowBorder">
                                  Read {key.os_readiops} IOPS
                                </td>
                                <td id="HalfRowBorder">
                                  {" "}
                                  {this.getTrendImage(
                                    key.current_os_disk_read_iops_trends
                                  )}
                                </td>
                              </tr>
                              <tr>
                                <td id="HalfRowBorder">
                                  Write {key.os_writeiops} IOPS
                                </td>
                                <td id="HalfRowBorder">
                                  {this.getTrendImage(
                                    key.current_os_disk_write_iops_trends
                                  )}
                                </td>
                              </tr>
                              <tr>
                                <td id="HalfRowBorder">
                                  Read Throughput {key.os_readthroughput} MBps
                                </td>
                                <td id="HalfRowBorder">
                                  {" "}
                                  {this.getTrendImage(
                                    key.current_os_disk_read_throughput_trends
                                  )}
                                </td>
                              </tr>
                              <tr>
                                <td id="HalfRow">
                                  Write Throughput {key.os_writethroughput} MBps
                                </td>
                                <td id="HalfRow">
                                  {this.getTrendImage(
                                    key.current_os_disk_write_throughput_trends
                                  )}
                                </td>
                              </tr>
                            </Table>
                          </td>
                          {/* <td>
                            <Table>
                              <tr>
                                <td id="HalfRowBorder">
                                  Read {key.adjusted_os_readiops} IOPS
                                </td>
                              </tr>
                              <tr>
                                <td id="HalfRowBorder">
                                  Write {key.adjusted_os_writeiops} IOPS
                                </td>
                              </tr>
                              <tr>
                                <td id="HalfRowBorder">
                                  Read Throughput{" "}
                                  {key.adjusted_os_readthroughput} MBps
                                </td>
                              </tr>
                              <tr>
                                <td id="HalfRow">
                                  Write Throughput{" "}
                                  {key.adjusted_os_writethroughput} MBps
                                </td>
                              </tr>
                            </Table>
                          </td> */}
                          {this.state.isAsp ? (
                            ""
                          ) : (
                            <td id="NumRightAlign">
                              <Table>
                                <tr>
                                  <td id="NumRightAlign">
                                    {" "}
                                    {priceDisplay(key.current_os_disk_price)}/mo
                                  </td>
                                </tr>
                              </Table>
                            </td>
                          )}
                          <td id="veticalAlignment">
                            <Table>
                              <tr>
                                {this.state.isAsp ? (
                                  <td id="InnerRow">
                                    Storage Used :{" "}
                                    {key.current_os_disk_utilisation}
                                  </td>
                                ) : (
                                  <td id="InnerRow">
                                    {key.current_os_disk_utilisation}
                                  </td>
                                )}
                              </tr>
                              <tr>
                                <td id="InnerRow">
                                  Read IOPS Usage{" "}
                                  {key.diskReadIOPS_OS_PERCENT_UTIL}
                                </td>
                              </tr>
                              <tr>
                                <td id="InnerRow">
                                  Write IOPS Usage{" "}
                                  {key.diskWriteIOPS_OS_PERCENT_UTIL}
                                </td>
                              </tr>
                              <tr>
                                <td id="InnerRow">
                                  Read Throughput Usage{" "}
                                  {key.diskReadThroughput_OS_PERCENT_UTIL}
                                </td>
                              </tr>
                              <tr>
                                <td id="InnerRow">
                                  Write Throughput Usage{" "}
                                  {key.diskWriteThroughput_OS_PERCENT_UTIL}
                                </td>
                              </tr>
                            </Table>
                          </td>
                          <td id="veticalAlignment">
                            <Table>
                              <tr>
                                <td id="InnerRow">
                                  {key.current_os_disk_health}
                                </td>
                              </tr>
                              {this.state.isAsp ? (
                                ""
                              ) : (
                                <tr>
                                  <td id="InnerRow">
                                    {this.state.hostOnly
                                      ? "IOPS Saturation"
                                      : "Read Latency"}{" "}
                                    ({key.diskReadLatency_OS_health_value}{" "}
                                    {this.state.hostOnly ? "%" : "milliseconds"}
                                    )
                                  </td>
                                </tr>
                              )}
                              {this.state.isAsp ? (
                                ""
                              ) : (
                                <tr>
                                  <td id="InnerRow">
                                    {this.state.hostOnly
                                      ? "Throughput Saturation"
                                      : "Write Latency"}{" "}
                                    ({key.diskWriteLatency_OS_health_value}{" "}
                                    {this.state.hostOnly ? "%" : "milliseconds"}
                                    )
                                  </td>
                                </tr>
                              )}
                              <tr>
                                {this.state.isAsp ? (
                                  <td id="InnerRow">
                                    Disk Queue Length (
                                    {parseFloat(
                                      key.diskAvgQueueLength_OS_health_value
                                    ).toFixed(4)}
                                    )
                                  </td>
                                ) : (
                                  <td id="InnerRow">
                                    Disk Queue (
                                    {key.diskAvgQueueLength_OS_health_value}{" "}
                                    count)
                                  </td>
                                )}
                              </tr>
                              <tr>
                                <td id="InnerRow">&nbsp;</td>
                                <td id="InnerRow">&nbsp;</td>
                              </tr>
                            </Table>
                          </td>
                        </tr>
                      ) : (
                        ""
                      );
                    })
                  : null}
                {this.state.entityType !== "db"
                  ? Object.keys(data.dataDisk).map((key) => {
                      return data.dataDisk[key].map((value, i) => {
                        // Format data disk size
                        const dataDiskSize = value?.current_data_disk_memory;
                        const dataDiskText = dataDiskSize
                          ? `${dataDiskSize}`
                          : null;
                        return i === 0 ? (
                          <tr key={i}>
                            <td id="InnerRow">
                              <Table>
                                <tr>
                                  <td id="InnerRow">
                                    Data Disk {value.data_disk_numm}-{" "}
                                    {value.current_data_disk_name
                                      ? value.current_data_disk_name.toUpperCase()
                                      : value.current_data_disk_name}
                                  </td>
                                </tr>
                              </Table>
                            </td>
                            <td>
                              <Table>
                                <tr>
                                  <td id="HalfRowBorderLimit">
                                    {value.current_data_disk_iops} IOPS{" "}
                                    {`(${dataDiskText})`}
                                  </td>
                                </tr>
                                <tr>
                                  <td id="HalfRowLimit">
                                    {value.current_data_disk_bandwidth}
                                  </td>{" "}
                                </tr>
                              </Table>
                            </td>
                            <td id="veticalAlignment">
                              <Table id="tableBorder">
                                <tr>
                                  <td id="HalfRowBorder">
                                    Read {value.dt_readiops} IOPS
                                  </td>
                                  <td id="HalfRowBorder">
                                    {this.getTrendImage(
                                      value.current_data_disk_read_iops_trends
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <td id="HalfRowBorder">
                                    Write {value.dt_writeiops} IOPS
                                  </td>
                                  <td id="HalfRowBorder">
                                    {this.getTrendImage(
                                      value.current_data_disk_write_iops_trends
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <td id="HalfRowBorder">
                                    Read Throughput {value.dt_readthroughput}{" "}
                                    MBps
                                  </td>
                                  <td id="HalfRowBorder">
                                    {this.getTrendImage(
                                      value.current_data_disk_read_throughput_trends
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <td id="HalfRow">
                                    Write Throughput {value.dt_writethroughput}{" "}
                                    MBps
                                  </td>
                                  <td id="HalfRow">
                                    {this.getTrendImage(
                                      value.current_data_disk_write_throughput_trends
                                    )}
                                  </td>
                                </tr>
                              </Table>
                            </td>
                            {/* <td id="veticalAlignment">
                              <Table id="tableBorder">
                                <tr>
                                  <td id="HalfRowBorder">
                                    Read {value.adjusted_dt_readiops} IOPS
                                  </td>
                                </tr>
                                <tr>
                                  <td id="HalfRowBorder">
                                    Write {value.adjusted_dt_writeiops} IOPS
                                  </td>
                                </tr>
                                <tr>
                                  <td id="HalfRowBorder">
                                    Read Throughput{" "}
                                    {value.adjusted_dt_readthroughput} MBps
                                  </td>
                                </tr>
                                <tr>
                                  <td id="HalfRow">
                                    Write Throughput{" "}
                                    {value.adjusted_dt_writethroughput} MBps
                                  </td>
                                </tr>
                              </Table>
                            </td> */}
                            <td id="NumRightAlign">
                              <Table>
                                <tr>
                                  <td id="NumRightAlign">
                                    {" "}
                                    {priceDisplay(
                                      value.current_data_disk_price
                                    )}
                                    /mo
                                  </td>
                                </tr>
                              </Table>
                            </td>
                            <td id="veticalAlignment">
                              <Table>
                                <tr>
                                  <td id="InnerRow">
                                    {value.current_data_disk_utilisation}
                                  </td>
                                </tr>
                                <tr>
                                  <td id="InnerRow">
                                    Read IOPS Usage{" "}
                                    {value.diskReadIOPS_PERCENT_UTIL}%
                                  </td>
                                </tr>
                                <tr>
                                  <td id="InnerRow">
                                    Write IOPS Usage{" "}
                                    {value.diskWriteIOPS_PERCENT_UTIL}
                                  </td>
                                </tr>
                                <tr>
                                  <td id="InnerRow">
                                    Read Throughput Usage{" "}
                                    {value.diskReadThroughput_PERCENT_UTIL}
                                  </td>
                                </tr>
                                <tr>
                                  <td id="InnerRow">
                                    Write Throughput Usage{" "}
                                    {value.diskWriteThroughput_PERCENT_UTIL}
                                  </td>
                                </tr>
                              </Table>
                            </td>
                            <td id="veticalAlignment">
                              <Table>
                                <tr>
                                  <td id="InnerRow">
                                    {value.current_data_disk_health}
                                  </td>
                                </tr>
                                <tr>
                                  <td id="InnerRow">
                                    {this.state.hostOnly
                                      ? "IOPS Saturation"
                                      : "Read Latency"}{" "}
                                    ({value.diskReadLatency_DT_health_value}{" "}
                                    {this.state.hostOnly ? "%" : "milliseconds"}
                                    )
                                  </td>
                                </tr>
                                <tr>
                                  <td id="InnerRow">
                                    {this.state.hostOnly
                                      ? "Throughput Saturation"
                                      : "Write Latency"}{" "}
                                    ({value.diskWriteLatency_DT_health_value}{" "}
                                    {this.state.hostOnly ? "%" : "milliseconds"}
                                    )
                                  </td>
                                </tr>
                                <tr>
                                  <td id="InnerRow">
                                    Disk Queue (
                                    {value.diskAvgQueueLength_DT_health_value}{" "}
                                    count)
                                  </td>
                                </tr>
                                <tr>
                                  <td id="InnerRow">&nbsp; </td>
                                  <td id="InnerRow">&nbsp; </td>
                                </tr>
                              </Table>
                            </td>
                          </tr>
                        ) : (
                          ""
                        );
                      });
                    })
                  : null}
              </tbody>
            </Table>
          </Col>
        </Row>
      </div>
    );
  }
}

export default CostHealthDetails;
